export const pipelineReport = {
  id: 'pipeline',
  name: 'Pipeline history',
  description: '',
  visibility: 'private',
  subject_type: 'pipeline',
  layout: {
    data: [
      {
        h: 7,
        w: 3,
        x: 0,
        y: 0,
        key: '4575',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 3,
        y: 0,
        key: '4576',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 6,
        y: 0,
        key: '4577',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 0,
        key: '4578',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 23,
        w: 12,
        x: 0,
        y: 7,
        key: '4579',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 30,
        key: '4580',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4575,
      subject_type: 'pipeline',
      metadata: {
        id: 'pipeline_applied',
        tileKey: 'pipeline_applied',
        apiParam: 'card',
        headerKey: 'applied',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4576,
      subject_type: 'pipeline',
      metadata: {
        id: 'pipeline_interviewed',
        tileKey: 'pipeline_interviewed',
        apiParam: 'card',
        headerKey: 'interviewed',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4577,
      subject_type: 'pipeline',
      metadata: {
        id: 'pipeline_offer',
        tileKey: 'pipeline_offer',
        apiParam: 'card',
        headerKey: 'offer',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4578,
      subject_type: 'pipeline',
      metadata: {
        id: 'pipeline_hired',
        tileKey: 'pipeline_hired',
        apiParam: 'card',
        headerKey: 'hired',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4579,
      subject_type: 'pipeline',
      metadata: {
        id: 'pipeline_chart',
        tileKey: 'pipeline_chart',
        apiParam: 'chart_table',
        headerKeys: [
          'application_review_total_count',
          'interviews_total_count',
          'offer_total_count',
          'hired_total_count',
        ],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4580,
      subject_type: 'pipeline',
      metadata: {
        id: 'pipeline_table',
        tileKey: 'pipeline_table',
        apiParam: 'chart_table',
        headerKeys: [
          'application_review_total_count',
          'interviews_total_count',
          'offer_total_count',
          'hired_total_count',
        ],
        componentType: 'table',
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
